import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { login } from "../services/Auth";
import loginImage from "../assets/loginimage.png";
import loginImage1 from "../assets/workers.png";
import { showSnackbar } from "./snackbar";
import ForgotPasswordModal from "./forgetpassword";
import { CartContext } from "../contextApi/CartContext";

const Login = ({ switchToSignUp, onClose, onSuccess }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserId } = useContext(CartContext);
  const redirectTo = location.state?.redirectTo || "/adminsidebar";

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");

    if (ref) {
      switchToSignUp();    
    }
  }, [switchToSignUp]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      setLoading(true);
      const response = await login(formData);

      if (response?.status === "Ok" && response?.access) {
        localStorage.setItem("token", response.access);
        localStorage.setItem("userId", String(response.userid));
        localStorage.setItem("userName", response.username || "");
        localStorage.setItem("userType", response.usertype || "");
        localStorage.setItem("firmName", response.firmname || "");
        localStorage.setItem("firstName", response.first_name || "");
        localStorage.setItem("mobile", response.Mobile || "");
        localStorage.setItem("email", response.email || "");
        localStorage.setItem("loginCount", response.login_count || "0");
        localStorage.setItem("GST", response.GST || "");
        localStorage.setItem("ReferalCode", response["Referal Code"] || "");
        localStorage.setItem("modules", response.Modules || "");
        setUserId(response.userid);
        showSnackbar("success", "Login successful!");
        onSuccess?.();     
        console.log("Usertype:", response.usertype);

        if (
          response.usertype === "SuperAdmin" ||
          // response.usertype === "Manager" ||
          response.usertype === "Warehouse" ||
          response.usertype === "Sales" ||
          response.usertype === "Marketing Manager"
        ) {
          console.log("Navigating to sidebar");
          navigate("/adminsidebar", { replace: true });
        } else {
          console.log("Navigating to home");
          navigate("/");
        }
        // window.location.reload();
      } else {
        setError("Invalid mobile number or password");
      }
    } catch {
      setError("Invalid mobile number or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <div style={styles.card}>
        <div style={styles.imageContainer}>
          <span style={styles.closeBtn} onClick={onClose}>
            ✕
          </span>
          <img src={loginImage} alt="Login" style={styles.image} />
        </div>

        <div style={styles.formContainer}>
          <h2 style={styles.title}>Sign In</h2>

          <form onSubmit={handleSubmit}>
            <input
              type="tel"
              name="email"
              placeholder="Mobile Number"
              value={formData.email}
              onChange={handleChange}
              style={styles.input}
              required
            />

            <div style={styles.passwordWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                style={styles.passwordInput}
                required
              />
              <span
                style={styles.eyeIcon}
                onClick={() => setShowPassword((p) => !p)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div style={styles.forgotBox}>
              <span style={styles.forgot} onClick={() => setShowForgot(true)}>
                Forgot password?
              </span>
            </div>

            {error && <p style={styles.error}>{error}</p>}

            <button
              type="submit"
              disabled={loading}
              style={{ ...styles.button, opacity: loading ? 0.6 : 1 }}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>

            <p style={styles.signupText}>
              Don’t have an account?{" "}
              <span onClick={switchToSignUp} style={styles.signupLink}>
                Sign up
              </span>
            </p>
          </form>
        </div>
      </div> */}
      <div style={styles.overlay}>
        <style>
          {`
@media (max-width: 900px) {
  .login-left {
    display: none !important;
  }

  .login-container {
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    width: 95% !important;
    max-width: 520px !important;
    height: auto !important;
    padding: 0 !important;
  }

  .login-right {
    width: 100% !important;
    padding: 25px 20px !important;
  }
}
`}
        </style>

        <div className="login-container" style={styles.container}>
          {/* <div className="login-left" style={styles.left}>
            <img src={loginImage1} style={styles.leftImage} />
          </div> */}

          {/* RIGHT FORM */}
          <div className="login-right" style={styles.right}>
            <span style={styles.closeBtn} onClick={onClose}>
              ✕
            </span>

            <h2 style={styles.heading}>
              <b>Login</b>
              {/* Hello , <b>Welcome To Pixel</b> */}
            </h2>

            {/* Social Buttons */}
            {/* <div style={styles.socialRow}>
              <button style={styles.socialBtn}>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/300/300221.png"
                  style={styles.icon}
                />
                Google
              </button>

              <button style={styles.socialBtn}>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/0/747.png"
                  style={styles.icon}
                />
                Apple
              </button>
            </div> */}

            <div style={styles.orRow}>
              {/* <div style={styles.line}></div> */}

              {/* <span style={styles.orText}>or Continue with</span> */}

              {/* <div style={styles.line}></div> */}
            </div>

            <form onSubmit={handleSubmit} style={styles.formInner}>
              <label style={styles.label}>Email & Mobile Number</label>

              <input
                type="tel"
                name="email"
                placeholder="Email & Mobile Number"
                value={formData.email}
                onChange={handleChange}
                style={styles.input}
                required
              />

              <label style={styles.label}>Password</label>

              <div style={styles.passwordWrapper}>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  style={styles.passwordInput}
                  required
                />

                <span
                  style={styles.eyeIcon}
                  onClick={() => setShowPassword((p) => !p)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div style={styles.forgotBox}>
                <span style={styles.forgot} onClick={() => {
                  setShowForgot(true);
                  console.log('clicked');
                }
                }>
                  Forgot Password?
                </span>
              </div>

              {error && <p style={styles.error}>{error}</p>}

              <button
                type="submit"
                disabled={loading}
                style={{
                  ...styles.loginBtn,
                  opacity: loading ? 0.6 : 1,
                }}
              >
                {loading ? "Signing In..." : "LOGIN"}
              </button>

              <p style={styles.signupText}>
                Don’t have an account?
                <span onClick={switchToSignUp} style={styles.signupLink}>
                  Sign up
                </span>
              </p>
            </form>
          </div>
        </div>
      </div>

      {showForgot && (<>{console.log("Modal Rendered")}
        <ForgotPasswordModal onClose={() => setShowForgot(false)} /></>
      )}
    </>
  );
};

export default Login;

/* ================= STYLES ================= */

const styles = {
  // page: {
  //   minHeight: "100vh",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   backgroundColor: "#f5f5f5",
  // },
  // closeBtn: {
  //   position: "absolute",
  //   top: "5px",
  //   right: "115px",
  //   fontSize: "22px",
  //   fontWeight: "bold",
  //   cursor: "pointer",
  //   color: "#f9f9f9",
  // },

  // card: {
  //   width: "90%",
  //   maxWidth: "420px",
  //   backgroundColor: "#fff",
  //   borderRadius: "16px",
  //   boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
  //   overflow: "hidden",
  //   display: "flex",
  //   flexDirection: "column",
  // },

  // imageContainer: {
  //   width: "100%",
  //   height: "240px",
  // },

  // image: {
  //   width: "100%",
  //   height: "100%",
  //   objectFit: "cover",
  // },

  // formContainer: {
  //   padding: "30px 25px",
  // },

  // title: {
  //   marginBottom: "25px",
  //   fontSize: "22px",
  //   fontWeight: "600",
  //   textAlign: "center",
  // },

  // input: {
  //   width: "100%",
  //   padding: "14px 18px",
  //   borderRadius: "30px",
  //   border: "1px solid #ddd",
  //   fontSize: "15px",
  //   marginBottom: "15px",
  //   outline: "none",
  // },

  // passwordWrapper: {
  //   position: "relative",
  //   marginBottom: "15px",
  // },

  // passwordInput: {
  //   width: "100%",
  //   padding: "14px 45px 14px 18px",
  //   borderRadius: "30px",
  //   border: "1px solid #ddd",
  //   fontSize: "15px",
  //   outline: "none",
  // },

  // eyeIcon: {
  //   position: "absolute",
  //   right: "18px",
  //   top: "50%",
  //   transform: "translateY(-50%)",
  //   cursor: "pointer",
  //   color: "#555",
  // },

  // forgotBox: {
  //   marginBottom: "20px",
  //   textAlign: "right",
  // },

  // forgot: {
  //   fontSize: "14px",
  //   cursor: "pointer",
  //   color: "#005487",
  // },

  // button: {
  //   width: "100%",
  //   padding: "14px",
  //   borderRadius: "30px",
  //   border: "none",
  //   backgroundColor: "#000",
  //   color: "#fff",
  //   fontSize: "16px",
  //   cursor: "pointer",
  //   marginBottom: "20px",
  // },

  // signupText: {
  //   textAlign: "center",
  //   fontSize: "14px",
  // },

  // signupLink: {
  //   fontWeight: "600",
  //   cursor: "pointer",
  //   color: "#005487",
  // },

  // error: {
  //   color: "red",
  //   fontSize: "14px",
  //   textAlign: "center",
  //   marginBottom: "10px",
  // },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(0,0,0,0.25)",
    zIndex: 9999,
    padding: "24px",
    overflowY: "auto",
  },

  container: {
    display: "flex",
    width: "100%",
    maxWidth: "560px",
    minHeight: "520px",
    maxHeight: "95vh",
    background: "#fff",
    borderRadius: "28px",
    overflow: "hidden",
    position: "relative",
    fontFamily: "Segoe UI, Arial, sans-serif",
    boxShadow: "0 30px 90px rgba(0,0,0,0.14)",
  },

  // left: {
  //   flex: "0 0 45%",
  //   minWidth: "240px",
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   background: "#f5f8ff",
  //   padding: "24px",
  // },

  // leftImage: {
  //   width: "100%",
  //   height: "100%",
  //   objectFit: "contain",
  // },

  right: {
    flex: "0 0 100%",
    minWidth: "240px",
    padding: "44px 36px",
    position: "relative",
    overflowY: "auto",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  closeBtn: {
    position: "absolute",
    top: "10px",
    right: "15px",
    cursor: "pointer",
    fontSize: "18px",
    color: "black",
  },

  heading: {
    marginBottom: "20px",
    fontWeight: "400",
    color: "black",
  },

  socialRow: {
    display: "flex",
    gap: "10px",
    marginBottom: "15px",
  },

  socialBtn: {
    flex: 1,
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    background: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center", 
    justifyContent: "center",
    gap: "8px",
    fontWeight: "600",
  },

  icon: {
    width: "18px",
    color: "black",
  },

  orRow: {
    display: "flex",
    alignItems: "center",
    margin: "20px 0",
  },

  line: {
    flex: 1,
    height: "1px",
    background: "#999",
  },

  orText: {
    margin: "0 10px",
    fontSize: "12px",
    color: "#555",
    whiteSpace: "nowrap",
  },
  label: {
    fontSize: "13px",
    marginBottom: "5px",
    display: "block",
    color: "black",
  },

  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #b1aeae",
    marginBottom: "15px",
  },

  formInner: {
    width: "100%",
    maxWidth: "520px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    alignItems: "stretch",
    margin: "0 auto",
  },

  passwordWrapper: {
    position: "relative",
  },

  passwordInput: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #b1aeae",
  },

  eyeIcon: {
    position: "absolute",
    right: "10px",
    top: "12px",
    cursor: "pointer",
    color: "black",
  },

  forgotBox: {
    textAlign: "right",
    marginTop: "5px",
    marginBottom: "15px",
    color: "black",
  },

  forgot: {
    fontSize: "12px",
    cursor: "pointer",
  },

  loginBtn: {
    width: "100%",
    padding: "14px",
    borderRadius: "10px",
    border: "none",
    background: "#0E5E7C",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
  },

  signupText: {
    marginTop: "15px",
    textAlign: "center",
    fontSize: "13px",
    color: "black",
  },

  signupLink: {
    marginLeft: "5px",
    fontWeight: "bold",
    cursor: "pointer",
  },

  error: {
    color: "red",
  },
};
